export const FETCH_PERSONAL_REQUEST = 'FETCH_PERSONAL_REQUEST'
export const FETCH_PERSONAL_SUCCES = 'FETCH_PERSONAL_SUCCES'
export const FETCH_PERSONAL_ERROR = 'FETCH_PERSONAL_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Personal.js